if (!customElements.get('wlsn-trade-in-steps')) {
  class WlsnTradeInSteps extends HTMLElement {
    constructor() {
      super();

      this.stepTypes = {
        PRODUCTS_LIST: 'step_products_list',
        PRODUCTS_CONDITION: 'step_products_condition', 
        PRODUCTS_RECOMMENDED: 'step_products_recommended'
      };

      this.cartRoutes = {
        // CART: '/cart.js',
        CLEAR: '/cart/clear.js',
        ADD: '/cart/add.js',
        UPDATE: '/cart/update.js'
      };

      this.classes = {
        active: 'active',
        scrollable: 'scrollable',
        tradeInTrigger: 'js-wlsn-trade-in-trigger',
        content: 'js-wlsn-trade-in-steps-content',
        step: 'js-wlsn-trade-in-steps-step',
        stepContent: 'js-wlsn-trade-in-steps-step-content',
        stepContentRecommended: 'js-wlsn-trade-in-steps-step-content-recommended',
        stepItemBox: 'js-wlsn-trade-in-steps-step-item-box',
        stepItemBoxProduct: 'js-wlsn-trade-in-steps-step-item-box-product',
        stepItemBoxCondition: 'js-wlsn-trade-in-steps-step-item-box-condition',
        stepItemBoxRecommendedItem: 'js-wlsn-trade-in-steps-product-recommended-item',
        stepItemBoxRecommendedBtn: 'js-wlsn-trade-in-steps-product-recommended-btn',
        footer: 'js-wlsn-trade-in-steps-footer',
        buttonPrevious: 'js-wlsn-trade-in-steps-nav-btn-previous',
        buttonNext: 'js-wlsn-trade-in-steps-nav-btn-next',
        data: 'js-wlsn-trade-in-steps-data',
        loader: 'js-wlsn-trade-in-steps-loader',
      };

      this.selectors = {
        header: 'wlsn-header-nav, wlsn-header',
        promoBar: '.js-wlsn-promo-bar'
      };

      this.resizeObserver = new ResizeObserver(this.handleResize.bind(this));
      this.windowResizeHandler = this.handleWindowResize.bind(this);
    }

    /**
     * Get elements
     * @returns {Object} - The elements
     */
    get elements() {
      return {
        tradeInTriggers: document.querySelectorAll(`.${this.classes.tradeInTrigger}`),
        content: this.querySelector(`.${this.classes.content}`),
        steps: this.querySelectorAll(`.${this.classes.step}`),
        stepContent: this.querySelectorAll(`.${this.classes.stepContent}`),
        stepContentRecommended: this.querySelector(`.${this.classes.stepContentRecommended}`),
        stepItemBox: this.querySelectorAll(`.${this.classes.stepItemBox}`),
        stepItemBoxProduct: this.querySelectorAll(`.${this.classes.stepItemBoxProduct}`),
        stepItemBoxCondition: this.querySelectorAll(`.${this.classes.stepItemBoxCondition}`),
        stepItemBoxRecommendedBtn: this.querySelectorAll(`.${this.classes.stepItemBoxRecommendedBtn}`),
        footer: this.querySelector(`.${this.classes.footer}`),
        buttonPrevious: this.querySelector(`.${this.classes.buttonPrevious}`),
        buttonNext: this.querySelector(`.${this.classes.buttonNext}`),
        data: this.querySelector(`.${this.classes.data}`),
        loader: this.querySelector(`.${this.classes.loader}`),
      };
    }

    /**
     * Get data
     * @returns {Object} - The data
     */
    get data() {
      const { data } = this.elements;
      return data ? JSON.parse(data.textContent) : {};
    }

    /**
     * Get current step
     * @returns {string} - The current step
     */
    get currentStepUnit() {
      return this.dataset.stateStep;
    }

    /**
     * Get steps size
     * @returns {string} - The steps size
     */
    get stepsSize() {
      return this.dataset.stateStepsSize;
    }

    /**
     * Get current step type
     * @returns {string} - The current step type
     */
    get currentStepType() {
      const currentStep = this.querySelector(`.${this.classes.step}[data-step="${this.currentStepUnit}"]`);
      return currentStep?.dataset.stepType;
    }

    /**
     * Connected callback
     * Called when the custom element is first connected to the document's DOM
     * Sets up initial state and event listeners
     */
    connectedCallback() {
      this.calculateStepContentHeights(this.currentStepUnit);
      
      const { content, tradeInTriggers, buttonNext, buttonPrevious, stepItemBoxProduct, stepItemBoxCondition } = this.elements;
      if (content) {
        this.resizeObserver.observe(content);
      }

      if (!!tradeInTriggers.length) {
        tradeInTriggers.forEach(trigger => {
          trigger.addEventListener('click', () => this.toggleTradeIn());
        });
      }

      if (buttonNext) {
        buttonNext.addEventListener('click', () => this.handleNextStep());
      }

      if (buttonPrevious) {
        buttonPrevious.addEventListener('click', () => this.handlePreviousStep());
      }

      if (stepItemBoxProduct.length) {
        stepItemBoxProduct.forEach(box => {
          box.addEventListener('click', () => this.handleProductBoxClick(box));
        });
      }

      if (stepItemBoxCondition.length) {
        stepItemBoxCondition.forEach(box => {
          box.addEventListener('click', () => this.handleConditionBoxClick(box));
        });
      }

      window.addEventListener('resize', this.windowResizeHandler);

      this.initRecommendedBtnListeners();
    }

    /**
     * Disconnected callback
     * Called when the custom element is removed from the document's DOM
     * Cleans up event listeners
     */
    disconnectedCallback() {
      const { content, tradeInTriggers, buttonNext, buttonPrevious, stepItemBoxProduct, stepItemBoxCondition, stepItemBoxRecommendedBtn } = this.elements;
      if (content) {
        this.resizeObserver.unobserve(content);
      }

      window.removeEventListener('resize', this.windowResizeHandler);

      if (!!tradeInTriggers.length) {
        tradeInTriggers.forEach(trigger => {
          trigger.removeEventListener('click', () => this.toggleTradeIn());
        });
      }

      if (buttonNext) {
        buttonNext.removeEventListener('click', () => this.handleNextStep());
      }

      if (buttonPrevious) {
        buttonPrevious.removeEventListener('click', () => this.handlePreviousStep());
      }

      if (stepItemBoxProduct.length) {
        stepItemBoxProduct.forEach(box => {
          box.removeEventListener('click', () => this.handleProductBoxClick(box));
        });
      }

      if (stepItemBoxCondition.length) {
        stepItemBoxCondition.forEach(box => {
          box.removeEventListener('click', () => this.handleConditionBoxClick(box));
        });
      }

      if (stepItemBoxRecommendedBtn.length) {
        stepItemBoxRecommendedBtn.forEach(btn => {
          btn.removeEventListener('click', () => this.handleRecommendedBtnClick(btn));
        });
      }
    }

    /**
     * Initialize recommended button click listeners
     * @returns {void}
     */
    initRecommendedBtnListeners() {
      const { stepItemBoxRecommendedBtn } = this.elements;
      if (stepItemBoxRecommendedBtn.length) {
        stepItemBoxRecommendedBtn.forEach(btn => {
          btn.addEventListener('click', () => this.handleRecommendedBtnClick(btn));
        });
      }
    }

    /**
     * Handle recommended button click
     * @param {HTMLElement} btn - The clicked button
     * @returns {void}
     */
    handleRecommendedBtnClick(btn) {
      const item = btn.closest(`.${this.classes.stepItemBoxRecommendedItem}`);
      if (!item) return;
    
      const data = JSON.parse(item.dataset.data);
      const{ product_main, product_returning, product_trade_in_diff, discounts, type } = data;
    
      const bundleId = 'b_' + crypto.randomUUID();
    
      const dataAdd = {
        items: [
          {
            id: product_trade_in_diff.variant_id,
            selling_plan: product_trade_in_diff.selling_plan_id,
            quantity: 1,
            properties: {
              _type: type,
              _product_type: 'bundle',
              _bundle_id: bundleId
            }
          },
          {
            id: product_main.variant_id,
            quantity: 1,
            properties: {
              _returning_product_id: product_returning.id,
              _returning_product_title: product_returning.title,
              _returning_product_variant_id: product_returning.variant_id,
              _product_type: 'main',
              _bundle_id: bundleId
            }
          },
        ]
      }
    
      const dataUpdate = discounts ? { discount: discounts } : null;
    
      this.addToCart(dataAdd, dataUpdate, true, '/checkout?skip_shop_pay=true');
    }

    /**
     * Add items to cart
     * @param {object} dataAdd - Data to add to cart
     * @param {object} dataUpdate - Data to update in cart
     * @param {boolean} clearCart - Whether to clear cart
     * @param {string} redirectUrl - Redirect URL
     * @returns {void}
     */
    async addToCart(dataAdd, dataUpdate = null, clearCart = false, redirectUrl = null) {
      try {
        let addResponse = null;
        let updateResponse = null;
        this.showLoading();
    
        if (clearCart) {
          const clearResponse = await fetch(this.cartRoutes.CLEAR, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          if (!clearResponse.ok) {
            throw new Error('Failed to clear cart');
          }
        }

        // Remove all discounts
        await fetch(this.cartRoutes.UPDATE, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ discount: '' })
        });
    
        // Add items to cart
        if (dataAdd) {
          addResponse = await fetch(this.cartRoutes.ADD, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataAdd)
          });
          if (!addResponse.ok) {
            const err = await addResponse.json();
            throw new Error(err.description || 'Failed to add items to cart');
          }
        }
    
        // Update cart 
        if (dataUpdate) {
          updateResponse = await fetch(this.cartRoutes.UPDATE, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataUpdate)
          });
          if (!updateResponse.ok) {
            throw new Error('Failed to update cart');
          }
        }

        if (window.cartType === 'cart_page') {
          if (redirectUrl && addResponse.ok || updateResponse.ok) {
            window.location.href = redirectUrl;
          }
        } else if (window.cartType === 'cart_drawer') {
          const drawer = document.querySelector('wlsn-cart-drawer');
      
          if (drawer) {
            await drawer.refreshDrawer();
            drawer.openDrawer();
          }
      
          this.hideTradeIn();
        }
    
      } catch (error) {
        console.error('Error adding items to cart:', error);
      } finally {
        this.hideLoading();
      }
    }

    /**
     * Handle resize events
     */
    handleResize() {
      this.calculateStepContentHeights(this.currentStepUnit);
    }

    /**
     * Handle viewport resize events
     * The header height changes with the viewport, so the offset has to be re-measured
     * before the step heights are recalculated against the new modal height.
     */
    handleWindowResize() {
      if (!this.classList.contains(this.classes.active)) return;

      this.setHeaderOffset();
      this.calculateStepContentHeights(this.currentStepUnit);
    }

    /**
     * Handle item box click
     * @param {HTMLElement} clickedBox - The clicked box
     * @param {string} boxSelector - The selector for boxes of same type
     * @returns {void} 
     */
    handleItemBoxClick(clickedBox, boxSelector) {
      const currentStep = clickedBox.closest(`.${this.classes.step}`);
      const stepItemBoxes = currentStep.querySelectorAll(boxSelector);
      
      // Remove active class from all boxes in current step
      stepItemBoxes.forEach(box => box.classList.remove(this.classes.active));
      
      // Add active class to clicked box
      clickedBox.classList.add(this.classes.active);

      // Enable next button if disabled
      const { buttonNext } = this.elements;
      if (buttonNext?.disabled) {
        buttonNext.disabled = false;
      }
    }

    /**
     * Handle product box click
     * @param {HTMLElement} clickedBox - The clicked product box
     * @returns {void}
     */
    handleProductBoxClick(clickedBox) {
      this.handleItemBoxClick(clickedBox, `.${this.classes.stepItemBoxProduct}`);
      // Update product ID in dataset
      this.dataset.stateProductId = clickedBox.dataset.productId;
    }

    /**
     * Handle condition box click
     * @param {HTMLElement} clickedBox - The clicked condition box
     * @returns {void}
     */
    handleConditionBoxClick(clickedBox) {
      this.handleItemBoxClick(clickedBox, `.${this.classes.stepItemBoxCondition}`);
      // Update condition in dataset
      this.dataset.stateCondition = clickedBox.dataset.condition;
    }

    /**
     * Populate recommended products step
     * @returns {void}
     */
    populateRecommendedProducts() {
      if ( this.currentStepType !== this.stepTypes.PRODUCTS_RECOMMENDED ) return;

      const { stepContentRecommended } = this.elements;
      const { stateProductId, stateCondition } = this.dataset;
      const productData = this.data[stateProductId];
      const includeOnly = stepContentRecommended?.dataset?.includeOnlyMainProducts;

      const includeOnlyIds = includeOnly
      ? includeOnly.split(',').map(id => id.trim())
      : [];


      if (
        !stepContentRecommended ||
        !stateProductId || 
        !stateCondition ||
        !productData?.length
      ) {
        stepContentRecommended.innerHTML = this.renderEmptyRecommendedProducts();
        return;
      }

      const filteredProducts = productData.filter(item => {
        if (!includeOnlyIds.length) return true;
    
        return includeOnlyIds.includes(String(item.main.id));
      });

      if (!filteredProducts.length) {
        stepContentRecommended.innerHTML = this.renderEmptyRecommendedProducts();
        return;
      }

      const recommendedProductsHTML = filteredProducts.map(item => {
        const mainData = item.main;
        const returningData = item.returning;
        const conditionData = item[stateCondition];
    
        if (
          !mainData?.variant_id ||
          !returningData?.variant_id ||
          !conditionData?.variant_id ||
          !conditionData?.selling_plan_id
        ) return '';

        return this.renderRecommendedProduct(
          {
            image: mainData.image,
            title: mainData.title,
            price: conditionData.price,
            priceStrikethrough: conditionData.price_strikethrough,
            priceDiff: conditionData.price_diff
          },
          {
            discounts: conditionData.discounts,
            type: conditionData.type,
            product_main: {
              id: mainData.id,
              variant_id: mainData.variant_id,
              title: mainData.title
            },
            product_returning: {
              id: returningData.id,
              variant_id: returningData.variant_id,
              title: returningData.title
            },
            product_trade_in_diff: {
              id: conditionData.id,
              variant_id: conditionData.variant_id,
              selling_plan_id: conditionData.selling_plan_id,
              title: conditionData.title
            },
          }
        );
      }).join('');

      stepContentRecommended.innerHTML = recommendedProductsHTML;
      
      // Reinitialize recommended button listeners after updating content
      this.initRecommendedBtnListeners();
    }

    /**
     * Render recommended product item
     * @param {Object} dataStatic - Static product data
     * @param {Object} dataDynamic - Dynamic product data
     * @returns {string} HTML string
     */
    renderRecommendedProduct(dataStatic, dataDynamic) {
      const { image, title, price, priceStrikethrough, priceDiff } = dataStatic;

      return `
        <article 
          class="wlsn-trade-in-steps__products-recommended-item wlsn-trade-in-steps__item-box js-wlsn-trade-in-steps-product-recommended-item"
          data-data='${JSON.stringify(dataDynamic).replace(/"/g, '&quot;')}'
        >
          <div class="wlsn-trade-in-steps__products-recommended-item-col wlsn-trade-in-steps__products-recommended-item-col--content">
            <img src="${image}" class="wlsn-trade-in-steps__products-recommended-item-image" />
            <div class="wlsn-trade-in-steps__products-recommended-item-content">
              <h3 class="wlsn-trade-in-steps__products-recommended-item-title wlsn-text-h3 md:wlsn-text-h5 lg:wlsn-text-h5">
                ${title}
              </h3>
              <div class="wlsn-trade-in-steps__products-recommended-item-price-wrapper">
                <span class="wlsn-trade-in-steps__products-recommended-item-price wlsn-font-medium wlsn-text-h4 md:wlsn-text-h6 lg:wlsn-text-h6">
                  ${price}
                </span>
                <s class="wlsn-trade-in-steps__products-recommended-item-price-strikethrough wlsn-text-h5 md:wlsn-text-body-medium lg:wlsn-text-body-medium">
                  ${priceStrikethrough}
                </s>
              </div>
              <span class="wlsn-trade-in-steps__products-recommended-item-price-info wlsn-font-medium wlsn-text-body-medium md:wlsn-text-body-small lg:wlsn-text-body-small">
                With ${priceDiff} trade-in
              </span>
            </div>
          </div>
          <div class="wlsn-trade-in-steps__products-recommended-item-col wlsn-trade-in-steps__products-recommended-item-col--btn">
            <button class="wlsn-trade-in-steps__products-recommended-item-btn wlsn-btn wlsn-btn--primary wlsn-btn--width-full js-wlsn-trade-in-steps-product-recommended-btn">
              Upgrade
            </button>
          </div>
        </article>
      `;
    }

    /**
     * Render empty recommended products step
     * @returns {string} HTML string
     */
    renderEmptyRecommendedProducts() {
      return `
        <p class="wlsn-trade-in-steps__products-recommended-empty-message wlsn-text-body-medium md:wlsn-text-body-small lg:wlsn-text-body-small">
          No trade-in recommendations available for the selected product.
        </p>`
      ;
    }

    /**
     * Check if step has any active item boxes and update next button state
     * @param {string} stepNumber - The step number to check
     * @returns {void}
     */
    updateNextBtnBasedOnActiveItemBox(stepNumber) {
      const step = this.querySelector(`.${this.classes.step}[data-step="${stepNumber}"]`);
      const hasActiveBox = step?.querySelector(`.${this.classes.stepItemBox}.${this.classes.active}`);
      
      const { buttonNext } = this.elements;
      if (buttonNext && step) {
        buttonNext.disabled = !hasActiveBox;
      }
    }

    /**
     * Handle previous step button click
     * @returns {void}
     */
    handlePreviousStep() {
      const currentStep = parseInt(this.currentStepUnit);
      
      if (currentStep > 1) {
        const previousStep = currentStep - 1;
        this.updateNextBtnBasedOnActiveItemBox(previousStep);
        this.dataset.stateStep = previousStep;
        this.calculateStepContentHeights(this.dataset.stateStep);
      }
    }

    /**
     * Handle next step button click
     * @returns {void} 
     */
    handleNextStep() {
      const currentStep = parseInt(this.currentStepUnit);
      const totalSteps = parseInt(this.stepsSize);

      if (currentStep < totalSteps) {
        const nextStep = currentStep + 1;
        this.updateNextBtnBasedOnActiveItemBox(nextStep);
        this.dataset.stateStep = nextStep;
        this.populateRecommendedProducts();
        this.calculateStepContentHeights(this.dataset.stateStep);
      }
    }

    /**
     * Calculate the height of the step content
     * @param {string} stepNumber - The step number to calculate height for
     * @returns {void}
     */
    calculateStepContentHeights(stepNumber) {
      const { stepContent, footer, content } = this.elements;
      if (!stepContent.length || !footer || !content) return;

      const contentHeight = content.offsetHeight;
      const currentStepContent = this.querySelector(`.${this.classes.step}[data-step="${stepNumber}"] .${this.classes.stepContent}`);
      
      if (!currentStepContent) return;

      const contentRect = content.getBoundingClientRect();
      const stepRect = currentStepContent.getBoundingClientRect();
      const topDistance = stepRect.top - contentRect.top;
      const stepContentHeight = contentHeight - topDistance - footer.offsetHeight;

      if (currentStepContent.scrollHeight > stepContentHeight) {
        currentStepContent.style.maxHeight = `${stepContentHeight}px`;
        this.classList.add(this.classes.scrollable);
      } else {
        currentStepContent.style.maxHeight = 'unset';
        this.classList.remove(this.classes.scrollable);
      }
    }

    /**
     * Measure the chrome pinned to the top of the viewport (promo bar + header), so the
     * modal can open below it instead of underneath it. The elements' own rects are the
     * source of truth for both the sticky and the non-sticky case - a header already
     * scrolled out of view reports a negative bottom and the modal takes the full viewport.
     * @returns {number} - The offset in px
     */
    getHeaderOffset() {
      const chrome = [
        ...document.querySelectorAll(this.selectors.header),
        ...document.querySelectorAll(this.selectors.promoBar)
      ];

      const bottoms = chrome
        .filter(element => element.getClientRects().length > 0)
        .map(element => (element.closest('.shopify-section') || element).getBoundingClientRect().bottom);

      return Math.max(0, ...bottoms);
    }

    /**
     * Expose the measured header offset to the stylesheet
     * @returns {void}
     */
    setHeaderOffset() {
      this.style.setProperty('--wlsn-trade-in-steps-offset-top', `${this.getHeaderOffset()}px`);
    }

    /**
     * Show trade in steps
     * @returns {void}
     */
    showTradeIn() {
      this.setHeaderOffset();
      this.classList.add(this.classes.active);
      this.bodyLock();
    }

    /**
     * Hide trade in steps
     * @returns {void}
     */
    hideTradeIn() {
      this.classList.remove(this.classes.active);
      this.bodyUnlock();
    }

    /**
     * Toggle trade in steps modal
     * @returns {void}
     */
    toggleTradeIn() {
      const isActive = this.classList.contains(this.classes.active);
      if (isActive) {
        this.hideTradeIn();
      } else {
        this.showTradeIn();
      }
    }

    /**
     * Show loading state
     * @returns {void}
     */
    showLoading() {
      this.elements.loader.classList.add(this.classes.active);
    }

    /**
     * Hide loading state
     * @returns {void}
     */
    hideLoading() {
      this.elements.loader.classList.remove(this.classes.active);
    }

    /**
     * Lock body scroll
     * @returns {void}
     */
    bodyLock() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    /**
     * Unlock body scroll
     * @returns {void}
     */
    bodyUnlock() {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  customElements.define('wlsn-trade-in-steps', WlsnTradeInSteps);
}